import {Component, NgZone, OnInit} from '@angular/core';
import {AppService} from '../../app.service';

declare let $: any;

@Component({
  selector: 'card-save-type-modal',
  templateUrl: './cardSaveTypeModal.component.html',
  styleUrls: ['./cardSaveTypeModal.component.css', '../../app.component.css']
})
export class CardSaveTypeModalComponent implements OnInit {

  constructor(private app: AppService, private zone: NgZone) {
  }

  ngOnInit() {

  }

  okClicked() {
    this.app.errorText = "";
    $('#cardSaveTypeModal').modal('hide');
  }

  overwriteTapped() {
    this.app.broadcast({event: 'overwriteCard'});
    $('#cardSaveTypeModal').modal('hide');
  }

  saveNewTapped() {
    this.app.broadcast({event: 'createNewCard'});
    $('#cardSaveTypeModal').modal('hide');
  }

  getVertPosition() {
    let modal = document.getElementById("cardSaveModalDialog");
    let height = modal.clientHeight;
    let width = modal.clientWidth;
    if (height === 0) {
      height = 150;
    }
    width = 300;
    // console.log("Modal height/width: ", height, width);
    let totalHeight = window.innerHeight;
    let totalWidth = window.innerWidth;
    // console.log("Error window size: ", window);
    return {position: "absolute", top: ((totalHeight - height) / 2) + 'px',
      left: ((totalWidth - width) / 2) + 'px', width: '300px', height: '150px'};
  }
}
